import * as React from 'react';
import { Script, ScriptStrategy } from 'gatsby';

const trackingCodes = [
    'G-ZDEXF1GT8K',
    'GTM-W2LKHJL',
];

const TrackingScripts: React.FC = () => (
    <>
        <Script
            src="//cdn.bc0a.com/autopilot/f00000000209368/autopilot_sdk.js"
            strategy={ScriptStrategy.idle}
        />

        {trackingCodes.map((code, index) => (
            <React.Fragment key={code}>
                <Script
                    id={`gtm-${index}`}
                    strategy={ScriptStrategy.idle}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: `
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({});
                    (function(w,d,s,l,i){
                        w[l]=w[l]||[];
                        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
                        var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
                        j.async=true;
                        j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl+'';
                        f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer', '${code}');
                        `,
                    }}
                />
                <noscript
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: `
                  <iframe title="${code}" src="https://www.googletagmanager.com/ns.html?id=${code}" height="0" width="0" style="display: none; visibility: hidden" aria-hidden="true"></iframe>
                          `,
                    }}
                />
            </React.Fragment>
        ))}
    </>
);

export default TrackingScripts;
